/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * Number field representation.
 */
export interface NumberClaimValue {
    /** The number field value. */
    value: number;
}
